import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import Login from "./pages/login";
import SignUp from "./pages/signUp";
import Validationcode from "./pages/validationCode";
import ConvertTextToSpeechh from "./pages/convertTextToSpeech";
import Archive from "./pages/archive";
import Wallet from "./pages/wallet";
import EditAccount from "./pages/editAccount";
import ForgotPassword from "./pages/forgotPassword";
import TextEditFeedback from "./pages/textEditFeedback";
import EnterMobile from "./pages/enterMobile";
import TotalForgotPass from "./pages/totalForgotPass";
import Support from "pages/support";

const queryClient = new QueryClient();

export const MainRouter = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <div>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <ConvertTextToSpeechh />
              </ProtectedRoute>
            }
          />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/enter-mobile" element={<EnterMobile />} />
          <Route path="/validation-code" element={<Validationcode />} />

          <Route
            path="/convert-text-to-speech"
            element={
              <ProtectedRoute>
                <ConvertTextToSpeechh />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wallet"
            element={
              <ProtectedRoute>
                <Wallet />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-account"
            element={
              <ProtectedRoute>
                <EditAccount />
              </ProtectedRoute>
            }
          />
          <Route
            path="/archive"
            element={
              <ProtectedRoute>
                <Archive />
              </ProtectedRoute>
            }
          />
          <Route
            path={"/convert-text-to-speech/edit/:id"}
            element={
              <ProtectedRoute>
                <TextEditFeedback />
              </ProtectedRoute>
            }
          />
          <Route path="/admin" />
          <Route path="/forgot-pass" element={<ForgotPassword />} />
          <Route path="/submit-forgot-pass" element={<TotalForgotPass />} />
          <Route path="/support" element={<Support />} />
          <Route
            path="/submit-forgot-pass"
            element={<h1>404 Page Not found</h1>}
          />
        </Routes>
      </div>
    </QueryClientProvider>
  );
};

const ProtectedRoute = ({ children }) => {
  if (!localStorage.getItem("token")) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
